export class WorkspaceNetworkingSettingsGcp {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vpcPeering",
            "baseName": "vpcPeering",
            "type": "GcpNetworkingSettingsVpcPeering",
            "format": ""
        },
        {
            "name": "privateServiceConnects",
            "baseName": "privateServiceConnects",
            "type": "Array<PscEndpoint>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceNetworkingSettingsGcp.attributeTypeMap;
    }
    constructor() {
    }
}
